import { ImageGalleryItem } from '../model/image-gallery-item';
export class ImageGalleryBuilder {
    static buildImageGallery(data) {
        if (Array.isArray(data)) {
            const imageGallery = data.map(item => {
                const imageGalleryItem = new ImageGalleryItem();
                imageGalleryItem.url = item.url ? item.url : null;
                return imageGalleryItem;
            });
            return imageGallery;
        }
        else
            return null;
    }
}
//# sourceMappingURL=image-gallery-builder.js.map